<template>
  <v-container>
    <v-card class="mx-auto" min-width="384px" max-width="512px">
      <v-card-title class="blue-grey white--text">
        <h3>Token [{{tokenName}}]</h3>
      </v-card-title>
      <v-tabs v-model="activeTab">
        <v-tab>Summary</v-tab>
        <v-tab>Access list</v-tab>
        <v-tab-item>
          <v-card-text>
            <v-alert v-if="token !== null" outlined type="info">
              <p>The new token is :</p>
              <p>{{token}}</p>
              <p>Please note this token will be display only once!</p>
            </v-alert>
            <v-alert v-if="token === null" color="orange" outlined type="info">
              <p>The token is hidden as it's already been displayed once after its creation</p>
              <p>If you have lost this one, you will have to delete this token and regenerate a new one</p>
            </v-alert>
            <v-text-field label="Token name" v-model="newTokenName" prepend-icon="mdi-label">
              <template v-slot:append>
                <v-btn
                  text
                  depressed
                  tile
                  class="ma-0"
                  @click="tokenNameUpdate"
                  :disabled="!newTokenName"
                  outlined
                >
                  <v-icon left>mdi-rename-box</v-icon>rename
                </v-btn>
              </template>
            </v-text-field>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="accesses">
            <v-card v-for="item in access.list" v-bind:key="item.dataType" class="ma-2">
              <v-card-title class="py-2">Access properties for [{{item.dataType}}] objects</v-card-title>
              <v-card-text class="pb-0">
                <v-radio-group
                  v-model="item.level"
                  label="Level:"
                  row
                  class="ma-0 pa-0"
                  @change="updateAccess(item)"
                >
                  <v-radio label="None" value="None"></v-radio>
                  <v-radio label="User" value="User"></v-radio>
                  <v-radio v-if="userIsAdmin" label="Administrator" value="Admin"></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="item.mode"
                  label="Mode:"
                  row
                  class="ma-0 pa-0"
                  @change="updateAccess(item)"
                >
                  <v-radio label="None" value="None"></v-radio>
                  <v-radio label="Read" value="Read"></v-radio>
                  <v-radio label="Write" value="Write"></v-radio>
                  <v-radio label="Manage" value="Manage"></v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-tab-item>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          @click="close({type: 'update', data: { tokenName: tokenName}})"
          color="orange white--text"
        >
          <v-icon>mdi-close</v-icon>Close
        </v-btn>
        <v-btn @click="remove" color="red white--text">
          <v-icon>mdi-delete</v-icon>Delete
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="removeDialog" max-width="380">
      <v-card>
        <v-card-title class="headline">Token delete</v-card-title>
        <v-card-text>
          <p>Do-you really want to remove the token {{tokenName}}?</p>
          <p>This operation is irreversible!</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="brown" @click="removeDialogConfirm()">
            <v-icon>mdi-delete-forever</v-icon>Confirm
          </v-btn>
          <v-btn color="orange" @click="removeDialogCancel()">
            <v-icon>mdi-cancel</v-icon>Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.accesses >>> .v-input--radio-group__input {
  display: contents;
}
.accesses >>> .v-input__slot {
  margin: 0px;
  padding: 0px;
}
.v-list-item {
  min-height: 0px;
}
.v-dialog.v-dialog--active .v-card__title {
  cursor: grab;
}
.v-dialog.v-dialog--active .v-card__title:active {
  cursor: grabbing;
}
.v-card__text.accesses {
  height: 512px;
  overflow-y: auto;
}
</style>

<script>
export default {
  name: "Token",
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {},
  computed: {
    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    }
  },
  data: () => ({
    token: "",
    tokenName: "",
    removeDialog: false,
    activeTab: 0,
    tabs: [
      { id: 1, name: "tab1" },
      { id: 2, name: "tab2" }
    ],
    access: { list: [] }
  }),
  watch: {
    id: function(value) {
      this.load(value);
    }
  },
  created() {
    this.load(this.id);
  },
  methods: {
    reset() {
      this.load(this.tokenName);
    },
    load(id) {
      this.tokenName = id;
      this.newTokenName = id;
      this.activeTab = 0;
      var accessList = [
        { dataType: "Config", mode: "None", level: "None" },
        { dataType: "Listing", mode: "None", level: "None" },
        { dataType: "UserSelf", mode: "None", level: "None" },
        { dataType: "User", mode: "None", level: "None" },
        { dataType: "Group", mode: "None", level: "None" },
        { dataType: "Role", mode: "None", level: "None" }
      ];
      var accesses = {
        Config: accessList[0],
        Listing: accessList[1],
        UserSelf: accessList[2],
        User: accessList[3],
        Group: accessList[4],
        Role: accessList[5]
      };
      this.$axios
        .get(`/users/self/tokens/${encodeURIComponent(this.tokenName)}`)
        .then(result => {
          this.token = result.data.token;
          this.$axios
            .get(
              `/users/self/tokens/${encodeURIComponent(
                this.tokenName
              )}/accesses`
            )
            .then(result => {
              result.data.forEach(e => {
                var a = accesses[e.data_type];
                if (a) {
                  a.mode = e.access_mode;
                  a.level = e.access_level;
                }
              });
              this.access.list = accessList;
            })
            .catch(result => {
              this.processErrorResponse(result);
              this.close();
            });
        })
        .catch(result => {
          this.processErrorResponse(result);
          this.close();
        });
    },
    processErrorResponse(result) {
      this.$emit("error", result);
    },
    tokenNameUpdate() {
      this.$axios
        .put("/users/self/tokens/" + encodeURIComponent(this.tokenName), {
          name: this.newTokenName
        })
        .then(() => {
          this.tokenName = this.newTokenName;
          this.$emit("success", "Token successfully updated");
        })
        .catch(result => {
          this.processErrorResponse(result);
        });
    },
    updateAccess(access) {
      this.$axios
        .put("/users/self/tokens/" + encodeURIComponent(this.tokenName) + "/accesses/" + access.dataType, {
          access_mode: access.mode,
          access_level: access.level,
        })
        .then(() => {
          this.tokenName = this.newTokenName;
          this.$emit("success", "Token successfully updated");
        })
        .catch(result => {
          this.processErrorResponse(result);
        });
    },
    remove() {
      this.removeDialogAdtion = () => {
        this.$axios
          .delete("/users/self/tokens/" + encodeURIComponent(this.tokenName))
          .then(() => {
            this.$emit("success", "Access successfully updated");
            this.close({ type: "delete" });
          })
          .catch(result => {
            this.processErrorResponse(result);
          });
      };
      this.removeDialog = true;
    },
    removeDialogConfirm() {
      this.removeDialogAdtion();
      this.removeDialogAdtion = null;
      this.removeDialog = false;
    },
    removeDialogCancel() {
      this.removeDialogAdtion = null;
      this.removeDialog = false;
    },
    close(data) {
      this.$emit("close", data);
    }
  }
};
</script>
